import React from "react";

const AmplitudeIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_840)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 16,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.102 12.4898C19.5918 13.9592 20.0816 15.8367 20.6531 17.9592C18.5306 17.9592 16.3265 17.8776 14.2857 17.8776H13.2245C14.449 13.2245 15.8367 9.63265 16.9796 8.81633C17.0612 8.73469 17.1429 8.73469 17.3061 8.73469C17.4694 8.73469 17.551 8.81633 17.7143 8.97959C17.8776 9.38776 18.3673 10.3673 19.102 12.4898ZM40 20C40 31.0204 31.0204 40 20 40C8.97959 40 0 31.0204 0 20C0 8.97959 8.97959 0 20 0C31.0204 0 40 8.97959 40 20ZM34.8571 19.5102C34.8571 19.0204 34.5306 18.5306 34.0408 18.449C33.9592 18.449 33.9592 18.449 33.8776 18.449H33.7143C30.3673 18.2041 26.8571 18.1224 23.5918 18.0408C22.0408 12.0816 20 6.04082 17.3878 6.04082C14.9388 6.04082 12.6531 10.0408 10.6939 17.8776C9.30612 17.8776 8.08163 17.8776 6.93878 17.7959C6.85714 17.7959 6.77551 17.7959 6.77551 17.7959C6.53061 17.7959 6.36735 17.7959 6.36735 17.7959C5.71429 17.8776 5.22449 18.5306 5.22449 19.1837C5.22449 19.8367 5.71429 20.4898 6.44898 20.5714H10.2041C9.87755 22.1224 9.55102 23.6735 9.30612 25.1429L9.22449 25.7959C9.22449 26.2857 9.63265 26.6939 10.1224 26.6939C10.449 26.6939 10.7755 26.5306 10.9388 26.2857L12.7347 20.4898H21.4694C22.1224 23.0204 22.8571 25.6327 23.7551 28.0816C24.2449 29.3878 25.3878 32.4898 27.3469 32.4898C30.2857 32.4898 31.4286 27.7551 32.1633 24.6531C32.3265 24 32.4898 23.4286 32.5714 22.9388L32.6531 22.7755C32.6531 22.6939 32.6531 22.6122 32.6531 22.5306C32.5714 22.3673 32.4898 22.2857 32.3265 22.2041C32.0816 22.1224 31.9184 22.2857 31.8367 22.5306L31.7551 22.6939C31.5102 23.3469 31.2653 24 31.102 24.5714V24.6531C29.7959 28.2449 29.2245 29.8776 28.0816 29.8776C26.6122 29.8776 25.2245 23.9184 24.7347 21.6327C24.6531 21.2245 24.5714 20.898 24.4898 20.5714H34.0408C34.2041 20.5714 34.3673 20.4898 34.5306 20.4898C34.5306 20.4898 34.5306 20.4898 34.6122 20.4898C34.6122 20.4898 34.6122 20.4898 34.6939 20.4898C34.6939 20.4898 34.7755 20.4898 34.7755 20.4082C34.6939 20.0816 34.8571 19.8367 34.8571 19.5102Z",
  fill: "#1E61F0"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_840"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(AmplitudeIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;